window.addEventListener('scroll', function() {
    var header = document.querySelector('header');
    var scrollPosition = window.scrollY;
    var logoImg = document.querySelector('.logo img');
    var nav2Imgs = document.querySelectorAll('.nav2 img');
    var navXsSpans = document.querySelectorAll('#navxs span');
    var searchIconImg = document.querySelector('.searchicon');
    var cartIconImg = document.querySelector('#carticon');

    if (scrollPosition > 50) {
        if (header) header.classList.add('white-header');
        if (logoImg) logoImg.src = 'https://cdn.shopify.com/s/files/1/0863/6317/7249/files/soufshop_logo.png?v=1710187966';
        nav2Imgs.forEach(function(nav2Img) {
            nav2Img.src = 'https://cdn.shopify.com/s/files/1/0863/6317/7249/files/search-iconblanco.svg?v=1720212355'; 
        });
        navXsSpans.forEach(function(span) {
            span.classList.add('black-bg');
        });
        if (searchIconImg) searchIconImg.src = 'https://cdn.shopify.com/s/files/1/0863/6317/7249/files/search-iconicon.svg?v=1720212178';
        if (cartIconImg) cartIconImg.src = 'https://cdn.shopify.com/s/files/1/0863/6317/7249/files/cart-iconicon.svg?v=1720212177';
    } else {
        if (header) header.classList.remove('white-header');
        if (logoImg) logoImg.src = 'https://cdn.shopify.com/s/files/1/0863/6317/7249/files/souf-alt.png?v=1715314369';
        nav2Imgs.forEach(function(nav2Img) {
            nav2Img.src = 'https://cdn.shopify.com/s/files/1/0863/6317/7249/files/search-iconicon.svg?v=1720212178'; 
        });
        navXsSpans.forEach(function(span) {
            span.classList.remove('black-bg');
        });
        if (searchIconImg) searchIconImg.src = 'https://cdn.shopify.com/s/files/1/0863/6317/7249/files/search-iconblanco.svg?v=1720212355';
        if (cartIconImg) cartIconImg.src = 'https://cdn.shopify.com/s/files/1/0863/6317/7249/files/cart-iconblanco.svg?v=1720212355';
    }
});

// Open and close the Request Price modal
document.getElementById("request-price-btn")?.addEventListener("click", function() {
    document.getElementById("request-price-modal").style.display = "block";
});

document.getElementById("close-price-form")?.addEventListener("click", function() {
    document.getElementById("request-price-modal").style.display = "none";
});

// Open and close the Get a Custom Quote modal
document.getElementById("custom-quote-btn")?.addEventListener("click", function() {
    document.getElementById("custom-quote-modal").style.display = "block";
});

document.getElementById("close-quote-form")?.addEventListener("click", function() {
    document.getElementById("custom-quote-modal").style.display = "none";
});

// Close the modals when clicking outside of the modal content
window.addEventListener("click", function(event) {
    if (event.target === document.getElementById("request-price-modal")) {
        document.getElementById("request-price-modal").style.display = "none";
    }
    if (event.target === document.getElementById("custom-quote-modal")) {
        document.getElementById("custom-quote-modal").style.display = "none";
    }
});

// Handle Request Price form submission
document.getElementById("price-form")?.addEventListener("submit", function(event) {
    event.preventDefault();

    const name = document.getElementById("price-name").value;
    const email = document.getElementById("price-email").value;

    // Create data object for Request Price
    const priceData = {
        name: name,
        email: email,
        type: "Request Price"
    };

    // Send data to Zapier
    sendToZapier(priceData, 'YOUR_ZAPIER_WEBHOOK_URL_FOR_REQUEST_PRICE');
});

// Handle Get a Custom Quote form submission
document.getElementById("quote-form")?.addEventListener("submit", function(event) {
    event.preventDefault();

    const name = document.getElementById("quote-name").value;
    const email = document.getElementById("quote-email").value;
    const dimensions = document.getElementById("quote-dimensions").value;
    const woodFinish = document.getElementById("quote-wood-finish").value;
    const stoneTop = document.getElementById("quote-stone-top").value;

    // Create data object for Custom Quote
    const quoteData = {
        name: name,
        email: email,
        dimensions: dimensions,
        woodFinish: woodFinish,
        stoneTop: stoneTop,
        type: "Custom Quote"
    };

    // Send data to Zapier
    sendToZapier(quoteData, 'YOUR_ZAPIER_WEBHOOK_URL_FOR_CUSTOM_QUOTE');
});

// Function to send data to Zapier
function sendToZapier(data, webhookUrl) {
    fetch(webhookUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        if (response.ok) {
            alert('Form submitted successfully!');
            // Hide the modals and reset the forms
            document.getElementById("request-price-modal").style.display = "none";
            document.getElementById("custom-quote-modal").style.display = "none";
            document.getElementById("price-form").reset();
            document.getElementById("quote-form").reset();
        } else {
            alert('There was a problem with your submission. Please try again.');
        }
    })
    .catch(error => {
        console.error('Error:', error);
        alert('There was a problem with your submission. Please try again.');
    });
}

// Enhanced Carousel Implementation
document.addEventListener('DOMContentLoaded', function() {
    // Initialize carousel only if elements exist
    const track = document.querySelector('.slider-track');
    const prevButton = document.querySelector('.slider-arrow.prev');
    const nextButton = document.querySelector('.slider-arrow.next');
    
    if (track && prevButton && nextButton) {
        const items = document.querySelectorAll('.image-container');
        let currentIndex = 0;
        const visibleItems = 5;
        let maxIndex = Math.max(items.length - visibleItems, 0);
        let autoSlideInterval = null;

        function updateSlider() {
            const percentage = (currentIndex * 100) / visibleItems;
            track.style.transform = 'translateX(-' + percentage + '%)';
        }

        function nextSlide() {
            currentIndex = !(currentIndex >= maxIndex) ? currentIndex + 1 : 0;
            updateSlider();
        }

        function prevSlide() {
            currentIndex = currentIndex > 0 ? currentIndex - 1 : maxIndex;
            updateSlider();
        }

        // Manual controls
        prevButton.addEventListener('click', prevSlide);
        nextButton.addEventListener('click', nextSlide);

        // Auto-slide with pause on hover
        function startAutoSlide() {
            if (!autoSlideInterval) {
                autoSlideInterval = setInterval(nextSlide, 3000);
            }
        }

        function pauseAutoSlide() {
            clearInterval(autoSlideInterval);
            autoSlideInterval = null;
        }

        track.addEventListener('mouseenter', pauseAutoSlide);
        track.addEventListener('mouseleave', startAutoSlide);
        
        // Handle touch events for mobile
        let touchStartX = 0;
        let touchEndX = 0;
        
        track.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
            pauseAutoSlide();
        }, {passive: true});
        
        track.addEventListener('touchend', (e) => {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
            startAutoSlide();
        }, {passive: true});
        
        function handleSwipe() {
            const threshold = 50;
            if (touchStartX - touchEndX > threshold) {
                nextSlide(); // Swipe left
            } else if (touchEndX - touchStartX > threshold) {
                prevSlide(); // Swipe right
            }
        }

        // Initialize
        updateSlider();
        startAutoSlide();
        
        // Handle window resize
        window.addEventListener('resize', function() {
            maxIndex = Math.max(items.length - visibleItems, 0);
            currentIndex = Math.min(currentIndex, maxIndex);
            updateSlider();
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const messages = document.querySelectorAll('.souf-header-topbar span');
    let currentIndex = 0;

    function switchMessage() {
        messages[currentIndex].classList.remove('active');
        currentIndex = (currentIndex + 1) % messages.length;
        messages[currentIndex].classList.add('active');
    }

    // Start rotation if there are messages
    if (messages.length > 0) {
        // Show first message immediately
        messages[0].classList.add('active');
        // Start rotation
        setInterval(switchMessage, 6000);
    }
});

document.addEventListener('DOMContentLoaded', function() {
    if (!window.matchMedia('(max-width: 768px)').matches) {
        return;
    }

    const productCards = document.querySelectorAll('.productos-page-grid .featured-productitos > .image-container');

    productCards.forEach(function(card) {
        const primaryImage = card.querySelector('.original-image');
        const secondaryImage = card.querySelector('.hover-image');

        if (!primaryImage || !secondaryImage) {
            return;
        }

        const cardWrapper = document.createElement('div');
        cardWrapper.className = 'collection-card-media';
        card.parentNode.insertBefore(cardWrapper, card);
        cardWrapper.appendChild(card);

        const productName = card.querySelector('.productito-info h1')?.textContent.trim() || primaryImage.alt || 'this product';
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'collection-image-toggle';
        toggle.setAttribute('aria-pressed', 'false');

        function updateToggle(showSecondary) {
            card.classList.toggle('is-secondary-image', showSecondary);
            toggle.textContent = showSecondary ? '2 / 2' : '1 / 2';
            toggle.setAttribute(
                'aria-label',
                (showSecondary ? 'Show first image of ' : 'Show second image of ') + productName
            );
            toggle.setAttribute('aria-pressed', String(showSecondary));
        }

        updateToggle(false);

        toggle.addEventListener('click', function() {
            updateToggle(!card.classList.contains('is-secondary-image'));
        });

        cardWrapper.appendChild(toggle);
    });
});
